import MaterialIconsReact from "material-icons-react";
import React from "react";
import Button from "./Button";
import styles from "./Modal.module.css";

function Modal(props) {
  const handleOk = (event) => {
    props.primaryAction(event);
  }

  return (
    <div data-testid="modal" className={styles.modalWrapper}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <div className="bold ft-16">{props.title}</div>
          {props.showClose !== false && <span data-testid="closeIcon" onClick={props.onClose}>
            <MaterialIconsReact size={24} color={'#666666'} icon={'close'}></MaterialIconsReact>
          </span>}
        </div>
        <div className={styles.modalContent} style={props.modalContentStyle}>
          {props.children}
        </div>
        {!props.footerSlot && props.primaryAction && <div className={styles.modalFooter}>
          <Button data-testid="secondaryModal" type={'secondary'} onClick={props.onClose}>Cancel</Button>
          <Button data-testid="primaryModal" type={'primary'} onClick={handleOk}>{props.primaryTitle || 'Add'}</Button>
        </div>}
        {props.footerSlot}
      </div>
    </div>
  );
}

export default Modal;